export interface PilotFAQItem {
  id: string;
  question: string;
  answer: string;
  accreditations?: {
    title: string;
    description: string;
  }[];
}

export const get__pilot_faq_data = (locale: string): PilotFAQItem[] => {
  const isUS = locale === 'en-us';
  
  return [
    {
      id: "1",
      question: "How long is a typical pilot?",
      answer: "Pilots usually run between 3 to 12 months, depending on scope. They can include up to 2,000 students and span multiple courses."
    },
    {
      id: "2", 
      question: "How much does the pilot package cost?",
      answer: "Our pilot package is affordable and comes with full support. It's designed to help you evaluate whether StudyStash delivers impact in the areas you care about, giving you the data to make an informed decision before investing in a full integration."
    },
    {
      id: "3",
      question: "How does evaluation work?",
      answer: "We use micro-surveys and pre/post analysis within StudyStash to measure outcomes such as student engagement, grades, and workload impact. This gives you clear, data-backed evidence of the pilot's success."
    },
    {
      id: "4",
      question: "Is StudyStash accessible, and what compliance accreditations do you have?",
      answer: "StudyStash is fully accessible and compliant with international standards. We maintain the following certifications and compliance reports:",
      accreditations: [
        {
          title: "ISO 27001 Certification",
          description: "Information security management system certification"
        },
        {
          title: isUS ? 'Section 508 Compliance' : 'WCAG 2.2 AA Compliance',
          description: "Web accessibility standards compliance"
        },
        {
          title: isUS ? 'HECVAT Assessment' : 'Penetration Attestation from CyberQ Group',
          description: "Security assessment and penetration testing"
        }
      ]
    }
  ];
};
